export default __webpack_public_path__ + "static/paketit-3218815bba6484f1621406f91174c11e.png";